import React from "react";

import UploadArquivosCanal from "../UploadArquivos";
import { CANAL_TRANSPORTADOR } from "../UploadArquivos/canais";

// A tela em si vive em ../UploadArquivos (PO1-2717): um componente para os dois
// canais. Este arquivo existe só para a rota do transportador não mudar de
// import. Some daqui o modal, o FileUpload single .zip e os console.log de
// debug que estavam em produção.
export default function UploadFilesTransporter() {
  return <UploadArquivosCanal canal={CANAL_TRANSPORTADOR} />;
}
